import { render, staticRenderFns } from "./DotsThree.vue?vue&type=template&id=27836b8c"
import script from "./DotsThree.vue?vue&type=script&lang=js"
export * from "./DotsThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports